const ID_FEDERAL = 'F';
const FEDERAL = {
	codigo: ID_FEDERAL,
	nome: 'Federal'
}

const ID_ESTADUAL = 'E';
const ESTADUAL = {
	codigo: ID_ESTADUAL,
	nome: 'Estadual'
}

const ID_MUNICIPAL = 'M';
const MUNICIPAL = {
	codigo: ID_MUNICIPAL,
	nome: 'Municipal'
}

export {ID_FEDERAL, ID_ESTADUAL, ID_MUNICIPAL, FEDERAL, ESTADUAL, MUNICIPAL }